<template>
  <div class="vx-row">
    <vx-card>
     
   <div class="text-center">


        <template v-for="value,key in  contactDataDescription['master_db_contact']">


          <vs-col>

            
              <template v-for="field_array_column in  selected_contact_fields">


                
                <template v-if="field_array_column.id == key">

                  <div v-if="field_array_column.identifier == 'company_name'">


                   <strong><span>Account : {{ value }}</span></strong> 
                    
  
         
          </div>

               


                </template>
                </template>
        </vs-col>
  
  
  
          </template>
        <p>
          Certain non-core fields associated with this contact already contain data in the master database. Please select the checkbox and submit to update the master database.
        </p>
        
      </div>

    
      <vs-row vs-w="12" class="mb-10 mt-10">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full"></div>


            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> Data Build Accounts</u></h6>
            </div>
          </div>
          <template v-for="value,key in  contactDataDescription['csv_contact']">


            <vs-col>
            <div class="vx-row mb-6" v-bind:class="has_different_value.includes(key)? 'bg-grey-gradient pt-5 pb-5 text-dark': ''">
              <div class="vx-col sm:w-1/2 w-full">
                


                <template v-for="field_array_column in  selected_contact_fields">


                  
                  <template v-if="field_array_column.id == key">

                    <span>{{ field_array_column.name }} :</span>

                  </template>
                </template>


               
              </div>
    
              <div class="vx-col sm:w-1/2 w-full">
                <template v-if="has_different_value.includes(key) && value != 'EMPTY'" v-model="contactDataDescription['csv_contact'][key]">



                  <template v-for="field_array_column in  selected_contact_fields">


                  
                    <template v-if="field_array_column.id == key">

                      <div style="height:100px;" v-if="field_array_column.identifier == 'none_core_field'">

                               <template v-if="Array.isArray(value)">


                    <template v-for="val1,index1 in value">

                      <template v-if="field_array_column.type == 'checkbox'">
 <input :checked="contactDataDescription['master_db_contact'][key].includes(val1)" @click="toggleConfirmedStatus(val1 , $event.target.checked , key)"
                      class="m-3" :name="key" type="checkbox" />

                      

                      </template>

                      <template v-else>

 <input @click="toggleConfirmedStatus(val1 , $event.target.checked , key)"
                      class="m-3" :name="key" type="checkbox" />

                      </template>


                     

                      {{ val1 }}





                      

                    </template>

                  </template>
                  <template v-else>

                   <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'" v-if="field_array_column.identifier == 'none_core_field' && has_different_value.includes(key)">

              

                    <template v-if="field_array_column.type == 'checkbox'">

                       <input :checked="contactDataDescription['master_db_contact'][key].includes(value)" @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                      class="m-3" :name="key" type="checkbox" />
                      </template>

                      <template v-else>

                        <input @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                        class="m-3" :name="key" type="checkbox" />
                      </template>

         
                     
                      {{ value }}


                    </div>

                 

         

                  </template>
                     



                </div>
                      <template v-else>


                        <div style="height:150px;" v-if="field_array_column.identifier == 'website' || field_array_column.identifier == 'linkedin' || field_array_column.identifier == 'phone' || field_array_column.identifier == 'switchboard'">

                         
                          
                          <template v-if="Array.isArray(value)">
        
                            <template v-for="val,index in value">


                              

                         

                              <input :checked="contactDataDescription['master_db_contact'][key].includes(val)" @click="toggleConfirmedStatus(val , $event.target.checked , key)"
                              class="m-3" :name="key" type="checkbox" />
                              {{ val }}

                              <br>
        


        
                            </template>
        
        
                            
        
        
                          </template>
                          <template v-else>

                            
                            <input :checked="contactDataDescription['master_db_contact'][key].includes(value)" @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                            class="m-3" :name="key" type="checkbox" />
                            {{ value }}
                          </template>
        
                   
        
        
        
                        </div>


                      <div v-else>



                       

                        <template v-if="Array.isArray(contactDataDescription['master_db_contact'][key]) && contactDataDescription['master_db_contact'][key].length > 0">
 <input :checked="contactDataDescription['master_db_contact'][key].includes(value)" @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                         :name="key" type="checkbox" />
                          

                        </template>

                        <template v-else>

                          <input :checked="contactDataDescription['master_db_contact'][key] == value" @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                          :name="key" type="checkbox" />
                          </template>

                          {{ value }}


                        
                    


                        
                      </div>

                      </template>



                   

                      <template v-else>

                        <input @click="toggleConfirmedStatus(value , $event.target.checked , key)"
                        :name="key" type="checkbox" />
                        {{ value }}
                        
               


                        
                    </template>
  
  
                    </template>




                  </template>
                </template>


                <template v-else>
                  


                  <template v-for="field_array_column in  selected_contact_fields">


                  
                    <template v-if="field_array_column.id == key">

                      <div style="height:150px;" v-if="field_array_column.identifier == 'website' || field_array_column.identifier == 'linkedin' || field_array_column.identifier == 'phone' || field_array_column.identifier == 'switchboard'">

                  
                        <template v-if="Array.isArray(value)">


                    <template v-for="val1 in value">
                     {{
                      val1
                      }}

                      <br>

                      

                    </template>

                  </template>
                  <template v-else>


                    {{ value }}
                  </template>


                  </div>

                  <template v-else>
                    


                   <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'" v-if="field_array_column.identifier == 'none_core_field' && has_different_value.includes(key)">

                      {{ value }}   



                    </div>
                    
                    <div v-else>

                      <template v-if="Array.isArray(value)">
                        <template v-for="val in value">
                       <span class="ml-1">{{
                        val
                      }} </span> 
  
                        </template>
  
                      </template>
  
                      <template v-else>
                        {{ value }}  
                        </template>


                    </div>
                        
    


                    
                </template>
                  
                    </template>
                   
                  </template>












            


                    


                </template>

               

               


              </div>
            </div>
            <vs-divider class="p-5" />
          </vs-col>
    
    
    
            </template>
        </vs-col>


        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full"></div>

            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> Master DB Accounts</u></h6>
            </div>
          </div>
          <template v-for="value,key in  contactDataDescription['master_db_contact']">


            <vs-col>
              <div class="vx-row mb-6" v-bind:class="has_different_value.includes(key)? 'bg-grey-gradient pt-5 pb-5 text-dark': ''">

                <div class="vx-col sm:w-1/3 w-full">
                </div>
                <template v-for="field_array_column in  selected_contact_fields">


                  
                  <template v-if="field_array_column.id == key">

                    <div style="height:150px;" v-if="field_array_column.identifier == 'website' || field_array_column.identifier == 'linkedin' || field_array_column.identifier == 'phone' || field_array_column.identifier == 'switchboard'">


            
    
              <div class="vx-col sm:w-1/2 w-full">

                    <template v-if="Array.isArray(value)">
                      <template v-for="val in value">
                      {{
                          val
                        }}
                        <br>

                      </template>

                    </template>

                    <template v-else>
                      {{ value }}  
                      </template>


              </div>
            </div>

                    <template v-else>

                     <div :style="field_array_column.field_type == 'textarea' ? 'height: ' + (contactDataDescription['csv_contact'][key].length / 2) + 'px;' : 'height:100px;'" v-if="field_array_column.identifier == 'none_core_field' && has_different_value.includes(key)">

                        <template v-if="Array.isArray(value)">
                          <template v-for="val in value">
                          {{
                              val
                            }}
    
                          </template>
    
                        </template>
    
                        <template v-else>
                          {{ value }}  
                          </template>

                        </div>

                        <div  v-else>

                          <template v-if="Array.isArray(value)">
                            <template v-for="val in value">
                            {{
                                val
                              }}
      
                            </template>
      
                          </template>
      
                          <template v-else>
                            {{ value }}  
                            </template>


                          </div>


                    </template>


                  </template>
                  </template>
            </div>
            <vs-divider class="p-5" />
          </vs-col>
    
    
    
            </template>
        </vs-col>
    


      </vs-row>

      <div class="text-center">
        <vs-button @click.prevent="submitForm">Submit</vs-button>

        <vs-button class="ml-5"  @click.prevent="cancelForm">Cancel</vs-button>
      </div>
   
    </vx-card>

     
  </div>
</template>

<script>
import moduleContactsManagement from '@/store/contacts-management/moduleContactsManagement.js'
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data: () => ({
    user_id: null,
    count_matched_contacts: [],
    importExcelDataToMasterDatabasePopUp: false,
    closeimportExcelDataToMasterDatabasePopUp: false,
    campaignName: null,
    has_different_value : [],
    configDateTimePicker: {
      enableTime: false,
      dateFormat: "Y-m-d"
    },
    review_changes: [],
    match_contacts: [],
    total_pages: 0,
    limit: 10,
    currentx: 1,
    paginate: { limit: 10, offset: 0 },
    contacts: {
      master_phone: [],
      master_switchboard: [],
      site_switchboard: [],
      master_site_switchboard: null,
      company_name: null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      head_office_country: null,
      company_registration_number: null,
      registration_jurisdiction: null,
      status: null,
      parent: null,
      web: [],
      master_web: null,
      master_linkedin: null,
      phone: null,
      linkedin: [],
      country: null,
      revenue: null,
      no_of_employees: null,
    },
    contactDataDescription: {},
    enrichOtherFieldAccountDataToMasterDBPopUp: false,
    abilities: null,
    table_name: null,
    log: [],
    dataSource: {},
    campaignDescription: [],
    enrichAccountDataToMasterDB: [],
    selected_contact_fields: [],
    updated_contact_description: [],
  }),
  components: {
    "v-select": vSelect,
    DataGrid,
    flatPickr
  },
  watch: {
    currentx: function (val, oldVal) {
      this.paginate = { limit: 10, offset: (val - 1) * this.limit};
      this.matchedData();
    },
  },
  methods: {
    removeDuplicates(arr) {
    let unique = arr.reduce(function (acc, curr) {
        if (!acc.includes(curr))
            acc.push(curr);
        return acc;
    }, []);
    return unique;
},
    toggleConfirmedStatus(val,toggle,key) {
      console.log(val);
      console.log(toggle);
      console.log(key);




      if (Array.isArray( this.updated_contact_description[key])){

        if (toggle == true) {
         this.updated_contact_description[key].push(val)
      } else {
         this.updated_contact_description[key] =  this.updated_contact_description[key].filter(function(value, index, arr){ return value != val;});
      }

      this.updated_contact_description[key] = this.removeDuplicates(this.updated_contact_description[key])

      console.log("updated_contact_description" , this.updated_contact_description[key])


      }else{
        if (toggle == true){
           this.updated_contact_description[key] = val
        }else{
           this.updated_contact_description[key] = null
        }
      }


      console.log("updated_contact_description" , this.updated_contact_description[key])


    },
 
    acceptToUpdate(data) {
      this.contactDataDescription = data;


      


      this.updated_contact_description = data['updated_csv']

      this.has_different_value =  this.contactDataDescription['has_different_value']




      for (let key in this.contactDataDescription['csv_contact']) {
        if (this.contactDataDescription['csv_contact'][key] == null || this.contactDataDescription['csv_contact'][key] == '') {
          this.contactDataDescription['csv_contact'][key] = "EMPTY";
        }

        if (Array.isArray( this.contactDataDescription['csv_contact'][key])){
            this.contactDataDescription['csv_contact'][key] = this.removeDuplicates(this.contactDataDescription['csv_contact'][key])
            
          }






        
      }

      for (let key in this.contactDataDescription['master_db_contact']) {
        if (this.contactDataDescription['master_db_contact'][key] == null || this.contactDataDescription['master_db_contact'][key] == '') {
          this.contactDataDescription['master_db_contact'][key] = "EMPTY";
        }


          if (Array.isArray( this.contactDataDescription['master_db_contact'][key])){
            this.contactDataDescription['master_db_contact'][key] = this.removeDuplicates(this.contactDataDescription['master_db_contact'][key])
            
          }


      }



      



    },
    cancelForm() {

          this.$router.push(
        '/data_build/build_contacts_list/' + this.campaignId
      )

    },
    submitForm() {


this.updated_contact_description['campaignId'] = this.campaignId;
this.updated_contact_description['accepted'] = this.contactDataDescription['accepted']
this.updated_contact_description['id'] = this.contactDataDescription['id']
let self = this;
      this.$vs.loading();



   




this.$store
  .dispatch("contactsManagement/updateDataBuildMasterDBContact",   this.updated_contact_description)
  .then(res => {
    if (res.data.status == "success") {
      this.$vs.notify({
        color: "success",
        title: "Account Updated",
        text: "The none core fields have been updated in the master database."
      });



                  this.$router.push(
        '/data_build/build_contacts_list/' + this.campaignId
      )




    }
  })
  .catch(err => {
    if (err.response.status === 401) {
      this.$router.replace("/login");
}
})
},
    finished() {

                this.importExcelDataToMasterDatabasePopUp = false;



this.$router
        .push("/contacts/compareNewExcelDataToMasterDb/" + this.campaignId)
        .catch(() => { });

      // this.$router
      //   .push("/contacts/matched/" + this.campaignId + '/' + btoa(this.campaignName))
      //   .catch(() => { });
    },
    IgnoreUpdateToMasterDB(data) {
      let self = this;

      let formData = {}
      formData.id = data.id;
      formData.campaignId = this.campaignId;



      this.$store
        .dispatch("contactsManagement/ignoreMasterDBAccount", formData)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Account Ignored",
              text: "This contact has been ignored."
            });
            this.matchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    goBack: function () {
      this.$router.go(-1);
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      if (s.startsWith("ml_")) return "";
      if (s === "master_db_contact") return "";
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s;
    },
    matchedData() {
    let self = this;
      this.$vs.loading()
      this.paginate.campaignId = this.campaignId;
      this.paginate.buildId = this.$route.params.buildId;
      axios
        .post(
          this.$base_url + "/api/contacts/enrich_data_build_contact_data_to_masterdatabase",
          this.paginate
        )
        .then(response => {

          console.log("RESS" , JSON.parse(response.data));


          this.match_contacts = JSON.parse(response.data).rows;

          if (this.match_contacts.length > 0) {


             this.acceptToUpdate(this.match_contacts[0]);
              if (this.match_contacts.length != 0) {
                  this.selected_contact_fields = JSON.parse(response.data).campaign_table_data;

              let total = JSON.parse(response.data).total_pages;
              this.total_pages = Math.ceil(total / this.limit);
              this.$vs.loading.close();


          }


          }else{
            this.$vs.loading.close();

          this.$router.push(
        '/data_build/build_contacts_list/' + this.campaignId
      )

          }


         





        
        })
        .catch(error => {
          console.log(error);
        });
    },

    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
          this.campaignName = this.campaignDescription.campaign_name;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
  },
  mounted() {
    this.getCampaignDescription()
    this.matchedData();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
     let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

        if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }


    this.campaignId = this.$route.params.campaignId;

    // this.getAssocaitedAccountsAccounts();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}


.width_class {
  width: 580px;
}

.imput_field {
  width: 500px;
}

.accept-button {
  cursor: pointer;
}
</style>

<style lang="stylus">

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: .75rem 1rem;
}

.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
